export const HTTP_REQUEST = "topBar/HTTP_REQUEST";
export const HTTP_SUCCESS = "topBar/HTTP_SUCCESS";
export const HTTP_FAILURE = "topBar/HTTP_FAILURE";
export const UPDATE_NOTIFICATION = "topBar/UPDATE_NOTIFICATION";
export const UPDATE_HISTORY = "topBar/UPDATE_HISTORY";
export const UPDATE_HISTORY_COUNT = "topBar/UPDATE_HISTORY_COUNT";
export const UPDATE_RWD_NAVBAR = "topBar/UPDATE_RWD_NAVBAR";
export const UPDATE_LOGIN_CHECK_NOTIFICATION = 'login/UPDATE_LOGIN_CHECK_NOTIFICATION'
